var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo, useState } from "react";
export var SolicitationContext = createContext({});
export var SolicitationProvider = function (_a) {
    var children = _a.children;
    var _b = useState({}), solicitation = _b[0], setSolicitation = _b[1];
    function saveData(data) {
        setSolicitation(data);
    }
    function getData() {
        return;
    }
    var contextValues = useMemo(function () { return ({ solicitation: solicitation, saveData: saveData, getData: getData }); }, [solicitation]);
    return (_jsx(SolicitationContext.Provider, __assign({ value: contextValues }, { children: children })));
};
